export default function addExperimentsFromQuery(runningExperiments, queryUtil, project) {
  const projValuePairRegex = new RegExp(`^(${project}:)(.*)|(.*)$`)

  const experiments = {}
  Object.keys(runningExperiments).forEach(key => { experiments[key] = runningExperiments[key] })


  const setPair = ([key, value]) => { experiments[key] = value }
  const getValueIfProj = str => str.replace(projValuePairRegex, '$2')

  const filterParamsForCurrProj = paramValue => paramValue
    .split(';')
    .map(getValueIfProj)
    .filter(Boolean)
    .join(',')

  const setParamValues = (param, value) => {
    let paramValue = queryUtil.getParameterByName(param)
    if (paramValue.indexOf(':') !== -1) { // Should be deprecated
      paramValue = filterParamsForCurrProj(paramValue)
    }
    paramValue
      .split(',')
      .filter(Boolean)
      .map(exp => [exp, value])
      .forEach(setPair)
  }

  const setProjParamExperiments = () => {
    queryUtil.getParameterByName(`${project}exp`)
      .split(',')
      .filter(Boolean)
      .map(exp => exp.split(':'))
      .map(([key, value]) => [key.toLowerCase(), value || 'new'])
      .forEach(setPair)
  }

  //////////////////

  setParamValues('experiments', 'new')
  setParamValues('experimentsoff', 'old')
  setProjParamExperiments()

  return experiments
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/lib/common/addExperimentsFromQuery.js